/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  FeeCreateAPIDataRequest
} from '../../model/feeCreateAPIDataRequest'
import type {
  FeeData
} from '../../model/feeData'
import type {
  FeeDataList
} from '../../model/feeDataList'
import type {
  FeeOverrideAPIDataRequest
} from '../../model/feeOverrideAPIDataRequest'
import type {
  GenericChartData
} from '../../model/genericChartData'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Get a list of Fees
 */
export const feeList = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FeeDataList>(
      {url: `/fund-family/${fundFamilyId}/fees/`, method: 'GET', signal
    },
      options);
    }
  

export const getFeeListQueryKey = (fundFamilyId: string,) => {
    return [`/fund-family/${fundFamilyId}/fees/`] as const;
    }

    
export const getFeeListQueryOptions = <TData = Awaited<ReturnType<typeof feeList>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeListQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeList>>> = ({ signal }) => feeList(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeList>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeListQueryResult = NonNullable<Awaited<ReturnType<typeof feeList>>>
export type FeeListQueryError = unknown

export const useFeeList = <TData = Awaited<ReturnType<typeof feeList>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeListQueryOptions(fundFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeList>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeListQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeList>>> = ({ signal }) => feeList(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeList>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeList>>>
export type FeeListSuspenseQueryError = unknown

export const useFeeListSuspense = <TData = Awaited<ReturnType<typeof feeList>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeListSuspenseQueryOptions(fundFamilyId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeListLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeListQueryKey(fundFamilyId),
              queryFn: () => feeList(fundFamilyId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Create a new Fee
 */
export const feeCreate = (
    fundFamilyId: string,
    feeCreateAPIDataRequest: FeeCreateAPIDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FeeData>(
      {url: `/fund-family/${fundFamilyId}/fees/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: feeCreateAPIDataRequest
    },
      options);
    }
  


export const getFeeCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeCreate>>, TError,{fundFamilyId: string;data: FeeCreateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof feeCreate>>, TError,{fundFamilyId: string;data: FeeCreateAPIDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof feeCreate>>, {fundFamilyId: string;data: FeeCreateAPIDataRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  feeCreate(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FeeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof feeCreate>>>
    export type FeeCreateMutationBody = FeeCreateAPIDataRequest
    export type FeeCreateMutationError = unknown

    export const useFeeCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeCreate>>, TError,{fundFamilyId: string;data: FeeCreateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFeeCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Create a fee override
 */
export const feesOverrideUpdate = (
    fundFamilyId: string,
    feeId: string,
    feeOverrideAPIDataRequest: FeeOverrideAPIDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FeeData>(
      {url: `/fund-family/${fundFamilyId}/fees/${feeId}/override/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: feeOverrideAPIDataRequest
    },
      options);
    }
  


export const getFeesOverrideUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feesOverrideUpdate>>, TError,{fundFamilyId: string;feeId: string;data: FeeOverrideAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof feesOverrideUpdate>>, TError,{fundFamilyId: string;feeId: string;data: FeeOverrideAPIDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof feesOverrideUpdate>>, {fundFamilyId: string;feeId: string;data: FeeOverrideAPIDataRequest}> = (props) => {
          const {fundFamilyId,feeId,data} = props ?? {};

          return  feesOverrideUpdate(fundFamilyId,feeId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FeesOverrideUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof feesOverrideUpdate>>>
    export type FeesOverrideUpdateMutationBody = FeeOverrideAPIDataRequest
    export type FeesOverrideUpdateMutationError = unknown

    export const useFeesOverrideUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feesOverrideUpdate>>, TError,{fundFamilyId: string;feeId: string;data: FeeOverrideAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFeesOverrideUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get a specific Fee
 */
export const feeRetrieve = (
    fundFamilyId: string,
    id: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FeeData>(
      {url: `/fund-family/${fundFamilyId}/fees/${id}/`, method: 'GET', signal
    },
      options);
    }
  

export const getFeeRetrieveQueryKey = (fundFamilyId: string,
    id: string,) => {
    return [`/fund-family/${fundFamilyId}/fees/${id}/`] as const;
    }

    
export const getFeeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feeRetrieve>>, TError = unknown>(fundFamilyId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeRetrieveQueryKey(fundFamilyId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeRetrieve>>> = ({ signal }) => feeRetrieve(fundFamilyId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feeRetrieve>>>
export type FeeRetrieveQueryError = unknown

export const useFeeRetrieve = <TData = Awaited<ReturnType<typeof feeRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeRetrieveQueryOptions(fundFamilyId,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeRetrieve>>, TError = unknown>(fundFamilyId: string,
    id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeRetrieveQueryKey(fundFamilyId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeRetrieve>>> = ({ signal }) => feeRetrieve(fundFamilyId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && id), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeRetrieve>>>
export type FeeRetrieveSuspenseQueryError = unknown

export const useFeeRetrieveSuspense = <TData = Awaited<ReturnType<typeof feeRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeRetrieveSuspenseQueryOptions(fundFamilyId,id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,id: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,id } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && id) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeRetrieveQueryKey(fundFamilyId,id),
              queryFn: () => feeRetrieve(fundFamilyId,id),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Edit a specific Fee
 */
export const feeUpdate = (
    fundFamilyId: string,
    id: string,
    feeCreateAPIDataRequest: FeeCreateAPIDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FeeData>(
      {url: `/fund-family/${fundFamilyId}/fees/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: feeCreateAPIDataRequest
    },
      options);
    }
  


export const getFeeUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeUpdate>>, TError,{fundFamilyId: string;id: string;data: FeeCreateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof feeUpdate>>, TError,{fundFamilyId: string;id: string;data: FeeCreateAPIDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof feeUpdate>>, {fundFamilyId: string;id: string;data: FeeCreateAPIDataRequest}> = (props) => {
          const {fundFamilyId,id,data} = props ?? {};

          return  feeUpdate(fundFamilyId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FeeUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof feeUpdate>>>
    export type FeeUpdateMutationBody = FeeCreateAPIDataRequest
    export type FeeUpdateMutationError = unknown

    export const useFeeUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeUpdate>>, TError,{fundFamilyId: string;id: string;data: FeeCreateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFeeUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Delete a specific Fee
 */
export const feeDestroy = (
    fundFamilyId: string,
    id: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/fees/${id}/`, method: 'DELETE'
    },
      options);
    }
  


export const getFeeDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeDestroy>>, TError,{fundFamilyId: string;id: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof feeDestroy>>, TError,{fundFamilyId: string;id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof feeDestroy>>, {fundFamilyId: string;id: string}> = (props) => {
          const {fundFamilyId,id} = props ?? {};

          return  feeDestroy(fundFamilyId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FeeDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof feeDestroy>>>
    
    export type FeeDestroyMutationError = unknown

    export const useFeeDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeDestroy>>, TError,{fundFamilyId: string;id: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFeeDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets fee summary data in chart format
 */
export const feeChargeEventStatsChartRetrieve = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericChartData>(
      {url: `/fund-family/${fundFamilyId}/fees/stats/chart`, method: 'GET', signal
    },
      options);
    }
  

export const getFeeChargeEventStatsChartRetrieveQueryKey = (fundFamilyId: string,) => {
    return [`/fund-family/${fundFamilyId}/fees/stats/chart`] as const;
    }

    
export const getFeeChargeEventStatsChartRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventStatsChartRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventStatsChartRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventStatsChartRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventStatsChartRetrieve>>> = ({ signal }) => feeChargeEventStatsChartRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventStatsChartRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventStatsChartRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventStatsChartRetrieve>>>
export type FeeChargeEventStatsChartRetrieveQueryError = unknown

export const useFeeChargeEventStatsChartRetrieve = <TData = Awaited<ReturnType<typeof feeChargeEventStatsChartRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventStatsChartRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventStatsChartRetrieveQueryOptions(fundFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeChargeEventStatsChartRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventStatsChartRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventStatsChartRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventStatsChartRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventStatsChartRetrieve>>> = ({ signal }) => feeChargeEventStatsChartRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventStatsChartRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventStatsChartRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventStatsChartRetrieve>>>
export type FeeChargeEventStatsChartRetrieveSuspenseQueryError = unknown

export const useFeeChargeEventStatsChartRetrieveSuspense = <TData = Awaited<ReturnType<typeof feeChargeEventStatsChartRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventStatsChartRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventStatsChartRetrieveSuspenseQueryOptions(fundFamilyId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeChargeEventStatsChartRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeChargeEventStatsChartRetrieveQueryKey(fundFamilyId),
              queryFn: () => feeChargeEventStatsChartRetrieve(fundFamilyId),
            }).then(() => null);
          }
          return null;
        });
      